$(function () {
  initMobileSizeModal();
  onChangeVariant();
  switchButtonAddToCart();
  addToCartMobile();
  closePopupCart();
  sortVariantOption();
  openMinicartMobile();
});

/**
 * Metodo per ordinare le taglie
 */
function sortVariantOption() {
  var stores_li = document.querySelectorAll(".modal-option");
  if (stores_li.length <= 0) {
    return;
  }
  Array.from(stores_li)
    .sort((a, b) => a.dataset.index.toLowerCase().localeCompare(b.dataset.index.toLowerCase()))
    .forEach((el) => el.parentNode.appendChild(el));
}

/**
 * Metodo per calcolare la percentuale tra due numeri
 */
function percDiff(etalon, example) {
  return +Math.abs(100 - (example / etalon) * 100).toFixed(10);
}

/**
 * Metodo che ritorna un JSON con le info del prodotto che sto visualizzando in pagina
 */
function getProductInfo() {
  var jsonData = JSON.parse(document.querySelector("[data-product-json]").innerHTML);
  return jsonData;
}

/**
 * Metodo per poplare il carrello popup dopo l'add-to-cart
 */
function insertProductIntoPopupCart(variantId) {
  // Product info
  var productDataJson = getProductInfo();
  var productInfoJson = productDataJson.product;

  // Product title
  var productTitle = productInfoJson.title;

  // Product image
  var productImageUrl = productInfoJson.featured_image;

  // Product color name
  var options = {
    includeScore: true,
    useExtendedSearch: true,
  };
  var fuse = new Fuse(productInfoJson.tags, options);
  var productColorName = fuse.search("^ColorName:");

  // Product main category
  var options = {
    includeScore: true,
    useExtendedSearch: true,
  };
  var fuse = new Fuse(productInfoJson.tags, options);
  var productMainCategory = fuse.search("^MainCategory:");

  // Variants
  var options = {
    includeScore: true,
    keys: ["id"],
    useExtendedSearch: true,
  };
  var fuse = new Fuse(productInfoJson.variants, options);
  var productVariant = fuse.search("^" + variantId);

  // Product variant title
  var productVariantTitle = null;
  if (typeof productVariant[0] !== "undefined" && productVariant[0].item.title) {
    productVariantTitle = productVariant[0].item.title;
  }

  // Product main category
  var mainCategory = null;
  if (typeof productMainCategory[0] !== "undefined" && productMainCategory[0].item.split(":")[1]) {
    mainCategory = productMainCategory[0].item.split(":")[1];
  }

  // Prezzo
  var productPrice = null;
  if (typeof productVariant[0] !== "undefined" && productVariant[0].item.price) {
    productPrice = productVariant[0].item.price;
  }

  // Prezzo di confronto
  var compareAtPrice = null;
  if (productVariant[0].item.compare_at_price) {
    compareAtPrice = productVariant[0].item.compare_at_price;
  }

  // Percentuale di sconto
  var productVariantPriceDiscount = null;
  if (compareAtPrice) {
    productVariantPriceDiscount = Math.ceil(percDiff(compareAtPrice, productPrice)) + "%";
  }

  // Color name
  var colorName = null;
  if (typeof productColorName[0] !== "undefined" && productColorName[0].item.split(":")[1]) {
    colorName = productColorName[0].item.split(":")[1];
  }

  /*
  console.log("variantId", variantId);
  console.log("productTitle", productTitle);
  console.log("productImageUrl", productImageUrl);
  console.log("productColorName", productColorName[0].item);
  console.log("productMainCategory", productMainCategory[0].item);
  console.log("productVariant", productVariant);
  console.log("productVariantPriceDiscount", productVariantPriceDiscount);
  */

  // Dom object popup cart
  var $productImagePopupCart = $(".product-image-popup-cart");
  var $productTitlePopupCart = $(".product-title-popup-cart");
  var $productCollectionPopupCart = $(".product-collection-popup-cart");
  var $productSizePopupCart = $(".product-size-popup-cart span");
  var $productPricePopupCart = $(".product-price-popup-cart");
  var $productPriceSalePopupCart = $(".product-price-sale-popup-cart");
  var $productDiscountPopupCart = $(".product-discount-popup-cart");
  var $productColorPopupCart = $(".product-color-popup-cart");

  // Insert into cart popup
  if (productImageUrl) {
    $productImagePopupCart.css("background-image", "url(" + productImageUrl + ")");
  }
  if (productTitle) {
    $productTitlePopupCart.html(productTitle);
  }
  if (productVariantTitle) {
    $productSizePopupCart.html(productVariantTitle);
  }
  if (mainCategory) {
    $productCollectionPopupCart.html(mainCategory);
  }

  $productPricePopupCart.html(Shopify.formatMoney(productPrice, window.theme.moneyFormat));
  if (compareAtPrice) {
    $productPriceSalePopupCart.html(Shopify.formatMoney(compareAtPrice, window.theme.moneyFormat));
  }
  if (productVariantPriceDiscount) {
    $productDiscountPopupCart.html(productVariantPriceDiscount);
  } else {
    $productDiscountPopupCart.css("margin", 0);
  }
  $productColorPopupCart.html(colorName);
}

/**
 * Metodo per visualizzare il popup cart
 */
function showPopupCart() {
  var VariantId = getVariantIdFromUrl();
  var $popupCart = $("#popup-cart");
  var $mobilePopupCartOverlay = $("#mobile-popup-cart-overlay");
  var $mobileButtonOpenSizeModal = $("#mobile-button-open-size-modal");
  var $buttonAddToCartNative = $("#btn-add-to-cart");
  var BtnTrigger;

  if (VariantId != null) {
    BtnTrigger = $buttonAddToCartNative;
  } else {
    BtnTrigger = $mobileButtonOpenSizeModal;
  }

  $mobilePopupCartOverlay.fadeTo("fast", 0.9, function () {
    BtnTrigger.fadeOut("fast");
  });
  $popupCart.show().addClass("animate__fadeInDown").addClass("isOpen");

  $(window).scrollTop(0);
}

/**
 * Metodo per nascondere il popup cart
 */
function closePopupCart() {
  var $popupCart = $("#popup-cart");
  var $closePopupCart = $(".close-popup-cart");
  var $mobilePopupCartOverlay = $("#mobile-popup-cart-overlay");

  $body = $("body");
  $closePopupCart.on("click", function () {
    $popupCart.removeClass("animate__fadeInDown").addClass("animate__fadeOutUp").removeClass("isOpen");
    $body.removeClass("stop-scroll");
    $mobilePopupCartOverlay.fadeOut();
    switchButtonAddToCart();
  });
  $popupCart.on("animationend", function () {
    var $self = $(this);
    if ($self.hasClass("animate__fadeOutUp")) {
      $popupCart.hide().removeClass("animate__fadeInDown animate__fadeOutUp");
    }
  });
}

/**
 * Metodo per effettuare l'add to cart dal popup delle taglie
 */
function addToCartMobile() {
  $(".size-swatch-mobile").on("click", function () {
    var $self = $(this);
    var variantId = $self.attr("data-variantid");
    var $errorVariantSelected = $(".error-variant-selected");
    var $closeMobileSizeModal = $(".close-mobile-size-modal");
    var $mobileButtonOpenSizeModal = $("#mobile-button-open-size-modal");
    var $notifyButton = $(".restock-alerts-notify-button");

    var data = {
      id: variantId,
      quantity: 1,
    };

    $notifyButton.hide();
    $mobileButtonOpenSizeModal.fadeOut("fast");
    if ($mobileButtonOpenSizeModal.attr("disabled") !== undefined) {
      $mobileButtonOpenSizeModal.removeAttr("disabled");
    }

    jQuery.ajax({
      type: "POST",
      url: "/cart/add.js",
      data: data,
      dataType: "json",
      success: function (data) {
        $errorVariantSelected.empty();
        $closeMobileSizeModal.trigger("click");
        insertProductIntoPopupCart(variantId);
        showPopupCart();
        document.documentElement.dispatchEvent(
          new CustomEvent("cart:refresh", {
            bubbles: true,
          })
        );
      },
      error: function (error) {
        var errorJson = error.responseJSON;
        var errorDescription = errorJson.description;
        $errorVariantSelected.html(errorDescription);
        $mobileButtonOpenSizeModal.fadeIn("fast");
        $mobileButtonOpenSizeModal.attr("disabled", "disabled");
        $notifyButton.fadeIn();
      },
    });
    document.documentElement.dispatchEvent(
      new CustomEvent("cart:refresh", {
        bubbles: true,
      })
    );
  });
}

/**
 * Funzione per cambiare il bottone add to cart mobile in add to cart nativo del tema
 */
function switchButtonAddToCart() {
  var $window = $(window);
  var $buttonAddToCartMobile = $("#mobile-button-open-size-modal");
  var $buttonAddToCartNative = $("#btn-add-to-cart");
  var variantId = getVariantIdFromUrl();

  if ($window.width() <= 1024) {
    // Variant selected
    if (variantId != "") {
      $buttonAddToCartMobile.hide();
      $buttonAddToCartNative.css("display", "flex");
    }
    // Variant no selected
    else {
      $buttonAddToCartMobile.css("display", "flex");
      $buttonAddToCartNative.hide();
    }
  }

  $window.resize(function () {
    var variantId = getVariantIdFromUrl();
    if ($window.width() <= 1024) {
      if (variantId != "") {
        $buttonAddToCartMobile.hide();
        $buttonAddToCartNative.css("display", "flex");
      }
      // Variant no selected
      else {
        $buttonAddToCartMobile.css("display", "flex");
        $buttonAddToCartNative.hide();
      }
    } else {
      $buttonAddToCartMobile.hide();
      $buttonAddToCartNative.css("display", "flex");
    }
  });
}

/**
 * Ritorna l'id della variante presente all'interno dell'URL
 */
function getVariantIdFromUrl() {
  const queryString = window.location.search;
  const urlParams = new URLSearchParams(queryString);
  const variantId = urlParams.get("variant");
  return variantId || "";
}

/**
 * Function on change variant select
 */
function onChangeVariant() {
  document.addEventListener("variant:changed", function (event) {
    var variant = event.detail.variant;
    var $buttonAddToCartMobile = $("#mobile-button-open-size-modal");
    var $buttonAddToCartNative = $("#btn-add-to-cart");
    $buttonAddToCartMobile.hide();
    $buttonAddToCartNative.css("display", "flex");
  });
}

/**
 * Init mobile modal select size
 */
function initMobileSizeModal() {
  // Obj DOM
  var $body = $("body");
  var $modal = $("#mobile-size-modal");
  var $buttonAddToCart = $("#mobile-button-open-size-modal");
  var $closeMobileSizeModal = $(".close-mobile-size-modal");
  var $mobileSizeModalOverlay = $("#mobile-size-modal-overlay");
  var $mobileSizeModalTitle = $(".mobile-size-modal-title");
  var $popupCart = $("#popup-cart");
  var $notifyButton = $(".restock-alerts-notify-button");
  const $mobileSizeTrigger = $(".mobile-size-modal-size-guide");

  // Trigger size guide button
  $mobileSizeTrigger.on("click", () => {
    let $sizingChartModalLink = $(".sizing-chart-modal-link");
    $sizingChartModalLink.trigger("click");
  });

  // Click button add to cart
  $buttonAddToCart.on("click touchstart", function (evt) {
    evt.preventDefault();
    // Modal is open
    if ($modal.hasClass("isOpen")) {
      $mobileSizeModalTitle.text(TEXT_SELECT_SIZE);
      return;
    }
    // Modal is close
    else {
      // Animate and add class isOpen
      $modal.show().addClass("animate__slideInUp").removeClass("animate__slideOutDown");
      $modal.addClass("isOpen");
      // Set height modal
      var hSizeSwatch = parseInt($("#mobile-size-modal .SizeSwatchList").height());
      $modal.height(parseInt($modal.height()) + hSizeSwatch - 120);
      // Show backgorund overlay
      $mobileSizeModalOverlay.fadeTo("fast", 0.9);
      // Stop scroll page when modal is open
      $body.addClass("stop-scroll");
      // Change button text add to cart when modal is open
      $buttonAddToCart.find(".ribbon__content").text(TEXT_ADD_SIZE);
    }
  });

  // Click button close modal
  $closeMobileSizeModal.on("click", function () {
    // Animate close modal
    $modal.removeClass("animate__slideInUp").addClass("animate__slideOutDown");
    // Reset modal height
    $modal.css("height", "auto");
    // Remove class isOpen
    $modal.removeClass("isOpen");
    // Reset title text size
    $mobileSizeModalTitle.text(TEXT_SIZE);
    // FadeOut modal overlay
    $mobileSizeModalOverlay.fadeOut();
    // Change text button add to cart
    $buttonAddToCart.find(".ribbon__content").text(TEXT_ADD_TO_CART);
    $notifyButton.hide();
    if ($buttonAddToCart.attr("disabled") !== undefined) {
      $buttonAddToCart.removeAttr("disabled");
    }
    // On animation close end
    $modal.on("animationend", function () {
      var $self = $(this);
      if ($self.hasClass("animate__slideOutDown")) {
        $modal.hide();
        $mobileSizeModalOverlay.hide();
        if (!$popupCart.hasClass("isOpen")) {
          $body.removeClass("stop-scroll");
        }
      }
    });
  });
}

// Funzione per aprire il minicart anche dal bottone nativo

function openMinicartMobile() {
  var $buttonAddToCartNative = $("#btn-add-to-cart");

  $buttonAddToCartNative.on("click", (e) => {
    if (window.innerWidth < 1024) {
      if ($buttonAddToCartNative.attr("data-action") != undefined && $buttonAddToCartNative.attr("data-action") == "add-to-cart") {
        var variantId = getVariantIdFromUrl();
        insertProductIntoPopupCart(variantId);
        showPopupCart();
      }
    }
  });
}
